import "text-encoding-polyfill";
import Joi from "joi";

const createCardSecondStepSchema = Joi.object({
  educationLevel: Joi.string().required(),
  course: Joi.string()
    .min(3)
    .max(50)
    .when("educationLevel", { is: "Ensino superior", then: Joi.required() }),
  uf: Joi.string().required(),
  city: Joi.string().min(3).max(20).required(),
  name: Joi.string().min(3).max(50).required(),
  cpf: Joi.string().min(14).max(14).allow(""),
  rg: Joi.string().max(15).allow(""),
  photo: Joi.string().required(),
});

export default createCardSecondStepSchema;
